import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getVehicleResponse from '@/types/responses/getVehicle';
import getDepartmentResponse from '@/types/responses/getDepartment';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

type ItemType = {
  number_plate: string;
  managementOfficeId: number;
  managementOfficeType: string;
  operationOfficeId: number;
  digital_tacograph: number;
  id: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleAutoComplete',
  props: {
    modelValue: {},
    selectedDepartment: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {},
    requestParams: {},
    filterAction: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<ItemType[]>([]);

onMounted(() => {
  Api()
    .autoComplete.vehicles(props.requestParams)
    .then((data) => {
      if (props?.filterAction) data = props?.filterAction(data)

      items.value = data.map((item: getVehicleResponse) => {
        return {
          number_plate: item.number_plate,
          managementOfficeId: item.management_officeable_id,
          managementOfficeType: item.management_officeable_type,
          operationOfficeId: item.operation_office_id,
          digital_tacograph: item.digital_tacograph,
          id: item.id,
          department_id: item.department_id,
        };
      });
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByDepartment = computed(() => {
  if (!props.selectedDepartment) return items.value
  return items.value.filter(item => item.department_id === props.selectedDepartment.id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "車番",
    itemName: "number_plate",
    items: filteredByDepartment.value,
    "management-office": __props.managementOffice,
    "operation-offices": props.operationOffices,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "items", "management-office", "operation-offices", "error-messages"]))
}
}

})